/* eslint-disable */
import { useEffect, useState } from "react";
import * as API from "../../framework/API/api";
import { ENTITYNAME , MEDIACATEGORIES, MEDIACATEGORYTYPES, PUBLISHING_SOURCE, MODULE } from "../constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { SeriesEditForm } from "../../modules/MediaLibrary/SeriesEditForm";
import { MediaEpisodeCollection } from "../../modules/MediaLibrary/MediaEpisodeCollection";
import SeasonEditForm from "../../modules/MediaLibrary/SeasonEditForm";
import { MediaEpisodeEditForm } from "../../modules/MediaLibrary/MediaEpisodeEditForm";
import { useTranslation } from "../../locale/useTranslation";
import { collectionMovieMenuModel, collectionProgramMenuModel, seasonMenuModel, seriesMenuModel } from "./helpercomponents/contextMenu/menus/collectionMenuModel";
import { useLocation } from "react-router-dom";
import { utility } from "../utility/utilityProvider";

export const MediaCollection = ({ mediaSubCategoryType }) => {

  const lang = useTranslation();

  if (!mediaSubCategoryType || !mediaSubCategoryType.MediaCategorySID) return null;

  switch (mediaSubCategoryType.MediaCategorySID) {

    case MEDIACATEGORIES.Series:

      return <MediaEpisodeCollection showTitle={false} publishingSource={PUBLISHING_SOURCE.Series} module={MODULE.MEDIA_EPISODE_SERIES} entityname={ENTITYNAME.Series} openNewEditForm={true} title={lang.series_page_breadcrumb} mediaCategory={MEDIACATEGORIES.Series} mediaCategoryType={MEDIACATEGORYTYPES.Series} customEditForm={SeriesEditForm} menuModel={seriesMenuModel} isPageable={true} mediaSubCategoryType={mediaSubCategoryType} />

    case MEDIACATEGORIES.Season:

      return <MediaEpisodeCollection showTitle={false} publishingSource={PUBLISHING_SOURCE.Season} module={MODULE.MEDIA_EPISODE_SEASON} entityname={ENTITYNAME.Season} openNewEditForm={true} title={lang.season_page_breadcrumb} customEditForm={SeasonEditForm} menuModel={seasonMenuModel} mediaCategory={MEDIACATEGORIES.Season} mediaCategoryType={MEDIACATEGORYTYPES.Season} isPageable={true} showFilterTemplate={true} mediaSubCategoryType={mediaSubCategoryType} />

    case MEDIACATEGORIES.Movie:

      return <MediaEpisodeCollection showTitle={false} publishingSource={PUBLISHING_SOURCE.MediaEpisode} module={MODULE.MEDIA_EPISODE_MOVIE} entityname={ENTITYNAME.MediaEpisode} preferenceEntityName={"movie"} title={lang.movies_page_breadcrumb} openNewEditForm={true} mediaCategory={MEDIACATEGORIES.Movie} mediaCategoryType={MEDIACATEGORYTYPES.Movie} wherestatement={['MediaCategory.SID', '=', MEDIACATEGORIES.Movie]} customEditForm={MediaEpisodeEditForm} menuModel={collectionMovieMenuModel} isPageable={true} showFilterTemplate={true} enableMutliSelect={true} enableMultipleUpdate={true} mediaSubCategoryType={mediaSubCategoryType} />

    case MEDIACATEGORIES.Program:

      return <MediaEpisodeCollection showTitle={false} publishingSource={PUBLISHING_SOURCE.MediaEpisode} module={MODULE.MEDIA_EPISODE_PROGRAM} entityname={ENTITYNAME.MediaEpisode} preferenceEntityName={"program"} title={lang.programs_page_breadcrumb} openNewEditForm={true} mediaCategory={MEDIACATEGORIES.Program} mediaCategoryType={MEDIACATEGORYTYPES.Program} wherestatement={['MediaCategory.SID', '=', MEDIACATEGORIES.Program]} customEditForm={MediaEpisodeEditForm} menuModel={collectionProgramMenuModel} isPageable={true} showFilterTemplate={true} enableMutliSelect={true} enableMultipleUpdate={true} mediaSubCategoryType={mediaSubCategoryType} />

    default:
      return null;;
  }
}

export const CommonMediaCollection = (props) => {

  const location = useLocation();

  const [mediaSubCategoryTypes, setMediaSubCategoryTypes] = useState([]);
  const [mediaSubCategoryType, setMediaSubCategoryType] = useState({});

  useEffect(() => {
    loadCombo();
  }, [])

  const loadCombo = async () => {
    let mediaSubCategoryTypeRes = await utility.getMediaSubCategoryTypeWithMCAndMCT();
    let filterLongType = mediaSubCategoryTypeRes.filter((x) => x.MediaCategory.isLong);
    setMediaSubCategoryTypes(filterLongType);
    if(location.state && location.state.mediaSubCategoryType) {
      let mediaSubCategoryType =   mediaSubCategoryTypeRes?.find(m => m.Description === location.state.mediaSubCategoryType);
      setMediaSubCategoryType(mediaSubCategoryType ?? location.state.mediaSubCategoryType );
    } else {
      setMediaSubCategoryType(mediaSubCategoryTypeRes[0]);
    }
  }

  return (
    <>
      <h1 className="page-title" style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
        <i className="fa fa-table marlr" style={{ fontSize: "30px", color: "GrayText", marginRight: "10px" }}></i>
        <DropDownList
          data={mediaSubCategoryTypes}
          name="MediaSubCategoryType"
          dataItemKey="_id"
          textField="Description"
          onChange={(e) => setMediaSubCategoryType(e.target.value)}
          value={mediaSubCategoryType}
          style={{ backgroundColor: 'white', height: '31px', width: '300px' }}
        />
      </h1>
      <MediaCollection mediaSubCategoryType={mediaSubCategoryType} />

    </>
  );
};